import styles from './FileUploading.module.scss';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import { Button } from '../Button';

type FileUploadingT = {
  handleClose?: () => void;
  label?: string;
  maxFileSize?: number;
  file?: File;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const FileUpload = ({ onChange, file, ...props }: FileUploadingT) => {
  const { t } = useTranslation();

  const [filed, meta] = useField(props);

  const placehoder = file ? file?.name : t('ChooseFile');

  return (
    <div>
      <div className={styles.title}>{`${t('FileUploadTitleCSV')}:`}</div>
      <label className={styles.file_label}>
        <span className={styles.file_select}>
          {meta.touched && meta.error ? <span className={styles.error}>{meta.error}</span> : placehoder}
        </span>
        <input type="file" {...filed} hidden onChange={onChange} />
        <span className={styles.file_button}>{t('FilesReview')}</span>
      </label>
    </div>
  );
};
